module.exports = __webpack_public_path__ + "assets/progress_circle.20bd8ca9.svg";